/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Copilot_Risk_MinimalInputs */



/**
* | output |
* | --- |
* | "Minimal Risk" |
*
* @param {Compliance_Copilot_Risk_MinimalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_copilot_risk_minimal = /** @type {((inputs?: Compliance_Copilot_Risk_MinimalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Copilot_Risk_MinimalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Minimales Risiko")
	return /** @type {LocalizedString} */ ("Minimal Risk")
});